import { Col, Input, Row, Space } from "antd";
import { FC } from "react";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
import { AddSvg, CancelIcon, SearchSvg } from "utils/svgs";
import { useSelector } from "react-redux";
import { checkPermission } from "utils/utils";
// For search filter and paginate
const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  // Init
  const {
    performSearchHandler,
    searchValue,
    openDrawerHandler,
    title,
    isSearchCancel,
    setSearch,
    setIsSearchCancel
  } = props;
  
  const userPermissions = useSelector(
    (state: any) => state?.userProfile?.data?.permissions
  );

  const isAddPermission = checkPermission(userPermissions, {
    permissionName: 'DoseForm',
    permission: ['add'],
  });

  // JSX
  return (
    <div className={styles["search-filter"]}>
      <div className={styles["search-filter__wrapper"]}>
        <Row justify={"space-between"}>
          <Col>
            <div className={styles["search-filter__wrapper--title"]}>{title}</div>
          </Col>
          <Col>
            <Space>
              <Input
                className={styles["search-filter__search"]}
                placeholder="Search Dose Form"
                prefix={<SearchSvg />}
                onChange={performSearchHandler}
                value={searchValue}
                size="large"
                suffix={
                  isSearchCancel && (
                    <span
                      style={{ display: "flex", cursor: "pointer" }}
                      onClick={() => {
                        setSearch('');
                        setIsSearchCancel(false);
                      }}
                    >
                      <CancelIcon />
                    </span>
                  )
                }
              />
              <div className={styles['user-table__action']}>
                {(isAddPermission) && (
                  <button
                    className={`btn-blue ${styles['user-table__action--button']}`}
                    onClick={openDrawerHandler}
                  >
                    <AddSvg />
                    <p>Add Dose Form</p>
                  </button>
                )}
              </div>
            </Space>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
